module.exports = __webpack_public_path__ + "static/media/14.3bc5526d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/14.mp3
// module id = 490
// module chunks = 0